import { compose, withProps } from 'recompose';
import EditControls from '../components/EditControls';
import AddControls from '../components/AddControls';
import { isEditMode } from '../helpers/isEditMode';

const withControls = compose(
  withProps(props => ({
    Controls: isEditMode(props) ? EditControls : AddControls,
  })),
);

export default withControls;
